"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.form.title.edit': 'Modifica conoscenza',
    'knowledge.form.title.add': 'Aggiungi conoscenza',
    'knowledge.form.back': 'Indietro',
    'knowledge.form.title.label': 'Titolo',
    'knowledge.form.title.placeholder': 'Inserisci titolo della conoscenza',
    'knowledge.form.description.label': 'Descrizione',
    'knowledge.form.description.placeholder': 'Inserisci descrizione della conoscenza',
    'knowledge.form.description.help': 'Fornire una breve descrizione per aiutare a identificare questa conoscenza',
    'knowledge.form.content.label': 'Contenuto',
    'knowledge.form.content.placeholder': 'Inserisci contenuto della conoscenza',
    'knowledge.form.file.label': 'File',
    'knowledge.form.file.placeholder': 'Seleziona file',
    'knowledge.form.project.label': 'Progetto',
    'knowledge.form.project.placeholder': 'Seleziona progetto',
    'knowledge.form.tags.label': 'Tag',
    'knowledge.form.tags.placeholder': 'Inserisci tag separati da virgole',
    'knowledge.form.tags.help': 'Usa Invio per aggiungere tag',
    'knowledge.form.contentType.label': 'Tipo di contenuto',
    'knowledge.form.contentType.help': 'Seleziona il tipo di contenuto che vuoi aggiungere',
    'knowledge.form.contentType.text': 'Testo',
    'knowledge.form.contentType.file': 'File',
    'knowledge.form.contentType.link': 'Link',
    'knowledge.form.contentType.googleDrive': 'Google Drive',
    'knowledge.form.contentType.google-drive': 'Google Drive',
    'knowledge.form.link.label': 'URL del link',
    'knowledge.form.link.placeholder': 'Inserisci l\'URL del link',
    'knowledge.form.googleDrive.label': 'URL di Google Drive',
    'knowledge.form.googleDrive.placeholder': 'Inserisci URL di condivisione Google Drive',
    'knowledge.form.googleDrive.selectFile': 'Seleziona da Google Drive',
    'knowledge.form.googleDrive.notAuthenticated': 'Google Drive non connesso. Si prega di collegare il proprio account nelle impostazioni.',
    'knowledge.form.googleDrive.notConnected': 'Google Drive non connesso',
    'knowledge.form.googleDrive.connect': 'Collega nelle Impostazioni',
    'knowledge.form.googleDrive.configureSettings': 'Configura nelle Impostazioni',
    'knowledge.form.googleDrive.statusError': 'Errore nel controllo dello stato di Google Drive',
    'knowledge.form.googleDrive.fileSelected': 'File Google Drive selezionato con successo',
    'knowledge.form.timed.label': 'Abilita disponibilità basata sul tempo',
    'knowledge.form.timed.help': 'Limita quando questa conoscenza è disponibile per gli avatar',
    'knowledge.form.startTime.label': 'Ora di inizio',
    'knowledge.form.startTime.placeholder': 'Seleziona data di inizio',
    'knowledge.form.endTime.label': 'Ora di fine',
    'knowledge.form.endTime.placeholder': 'Seleziona data di fine',
    'knowledge.form.active.label': 'Attivo',
    'knowledge.form.active.help': 'Abilita questa conoscenza per l\'uso',
    'knowledge.form.rag_status.label': 'Stato RAG',
    'knowledge.form.content_type.label': 'Tipo di Contenuto',
    'knowledge.form.submit.update': 'Aggiorna conoscenza',
    'knowledge.form.submit.create': 'Crea conoscenza',
    'knowledge.form.reset.debug': 'Ripristino modulo allo stato iniziale',
    'knowledge.form.reset.complete': 'Ripristino parti del modulo completato',
    'knowledge.form.reset.forNext': 'Ripristino modulo per la prossima voce',
    'knowledge.form.projects.loadError': 'Errore nel caricamento progetti:',
    'knowledge.form.load.error': 'Errore nel caricamento conoscenza',
    'knowledge.form.submit.duplicateWarning': 'Invio modulo già in corso, ignorando invio duplicato',
    'knowledge.form.submit.starting': 'Avvio invio modulo con dati:',
    'knowledge.form.submit.updating': 'Aggiornamento conoscenza con ID:',
    'knowledge.form.submit.creating': 'Creazione nuova voce di conoscenza',
    'knowledge.form.submit.updateError': 'Errore nell\'aggiornamento conoscenza',
    'knowledge.form.submit.createError': 'Errore nella creazione conoscenza',
    'knowledge.form.submit.updateSuccess': 'Conoscenza aggiornata con successo',
    'knowledge.form.submit.createSuccess': 'Conoscenza creata con successo',
    'knowledge.form.submit.success': 'Conoscenza creata con successo:',
    'knowledge.form.submit.error': 'Errore nel salvataggio conoscenza:',
    'knowledge.form.validation.fileRequired': 'Il file è richiesto',
    'knowledge.form.validation.timedDatesRequired': 'Sia l\'ora di inizio che quella di fine sono richieste quando il tempo è abilitato',
    'knowledge.form.ragOverride.title': 'Sovrascrittura Impostazioni Indicizzazione',
    'knowledge.form.ragOverride.description': 'Opzionalmente sovrascrivi le impostazioni di indicizzazione RAG predefinite per questa voce di conoscenza.',
};
